import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-home-features',
    standalone: true,
    imports: [CommonModule,TranslateModule,RouterModule],
    templateUrl: './home-features.component.html',
})
export class HomeFeaturesComponent {

    constructor(private router: Router){}

    redirectOnClick(routeName){
      this.router.navigate([routeName]);
    }
}
